export const buildVariantCloseStylesheet = (builder, device, cta, variant) => {
    let options = { ...variant.options };

    let iconDisplay = "block";

    if (options["close-icon-show"] == "false") {
      iconDisplay = "none";
    }

    let backgroundColor = options["close-icon-background"]
      ? options["close-icon-background"]
      : "#f2f5f9";

    let iconSize = `${
      variant.options["close-icon-size"]
        ? variant.options["close-icon-size"]
        : 12
    }px`;

    let iconSizeMobile = `${
      variant.options["close-icon-size-mobile"]
        ? variant.options["close-icon-size-mobile"]
        : iconSize
    }px`;

    // prettier-ignore
    let desktopStyles = 
`#cta_${cta.id} .cf-close[data-cta-id="${cta.id}"] {
  all: initial !important;
  background: ${backgroundColor} !important;
  display: ${iconDisplay} !important;
  position: absolute !important;
  right: 10px !important;
  top: 10px !important;
  padding: 5px !important;
  line-height: 0 !important;
  border-radius: 100% !important;
  cursor: pointer !important;
  z-index: ${builder ? '21' : '9'} !important;
  opacity: 1 !important;
}

#cta_${cta.id} .cf-close[data-cta-id="${cta.id}"]:focus {
  opacity: 0.5 !important;
  outline: 2px solid #007cba !important;
  outline-offset: 2px !important;
  box-shadow: 0 0 0 2px rgba(0, 124, 186, 0.3) !important;
}

#cta_${cta.id} .cf-close[data-cta-id="${cta.id}"] svg {
  width: ${iconSize} !important;
  height: ${iconSize} !important;
}
`;

    if (builder !== true) {
      desktopStyles += `
#cta_${cta.id} .cf-close[data-cta-id="${cta.id}"] {
  z-index: 99999 !important;
}`;
    }

    // prettier-ignore
    const mobileStyles = 
`/* mobile styles */
#cta_${cta.id} .cf-close[data-cta-id="${cta.id}"] svg {
  width: ${iconSizeMobile} !important;
  height: ${iconSizeMobile} !important;
}

#cta_${cta.id} .cf-close[data-cta-id="${cta.id}"]:focus {
  opacity: 0.5 !important;
  outline: 2px solid #007cba !important;
  outline-offset: 1px !important;
  box-shadow: 0 0 0 2px rgba(0, 124, 186, 0.3) !important;
}
`;

    if (builder !== true) {
      return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
    } else {
      if (device == "desktop") {
        return desktopStyles;
      } else {
        return desktopStyles + mobileStyles;
      }
    }
};
